import React from 'react';
import './Reminder.css';

const Reminder = ({  }) => {
  return (
    <div style={{ margin: '10px' }}>
      <div 
        style={{
          margin: '10px', 
          display: 'flex', 
          flexDirection: 'row', 
          justifyContent: 'space-between', 
          alignItems: 'center'
        }} 
        className="content-center"
      >
        <h3 className="headings" style={{ fontFamily: 'Roboto', color: '#FECB00' }}>
          Don't forget to add the source!
        </h3>
      </div>
        <img 
          id="gif" 
          style={{
            width: '400px', 
            border: '5px solid #fecb00', 
            borderRadius: '10px'
          }} 
          src="/gif.gif" 
          alt="Reminder" 
        />
    </div>
  );
};

export default Reminder;
